export default __webpack_public_path__ + "static/nozawa-japan-8f8678fca070c87b60f3b374c66b15de.jpg";